import { Modal } from "react-bootstrap";
import React, { useEffect } from "react";
import ModalBody from "./components/ModalBody";
import { MODAL } from "./helpers/constants";
import { useLoaderData, useNavigate } from "react-router-dom";
import { ProductInterface } from "../../types/common.types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import FeedbackAlert from "../extras/Alert";
import { setModalState, setSelectedProduct } from "../../redux/slices/AppState";
import { emptyProductObject } from "../../helpers/generic";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "../../hooks/useTranslation";
import { ProductType } from "../product";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

interface ModalProps {
  show: boolean;
  productType: number;
  modalModeInit: number;
}
export interface LoaderXHR {
  success: boolean;
  product: ProductInterface;
}
const ProductModal = (props: ModalProps) => {
  const { show, productType, modalModeInit } = props;
  const { feedback, modalMode } = useSelector((state: RootState) => state.App);
  const { drinks, food } = useSelector((state: RootState) => state.Product);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let loaderData = useLoaderData() as LoaderXHR | undefined;

  const somethingWentWrong = useTranslation("something_went_wrong");
  const newProductHeading = useTranslation("new_product_heading");
  const viewProductHeading = useTranslation("view_product_heading");
  const editProductHeading = useTranslation("edit_product_heading");

  const productId = loaderData?.product?.id;
  const productInState = [...drinks, ...food].find(
    (product) => product.id === productId
  );

  useEffect(() => {
    dispatch(setModalState(modalModeInit));
    return () => {
      dispatch(setModalState(MODAL.NULL));
    };
    // eslint-disable-next-line
  }, []);

  const onModalHide = () => {
    dispatch(setSelectedProduct(emptyProductObject));
    if (productType === ProductType.Drink) navigate("/app/drinks");
    if (productType === ProductType.Food) navigate("/app/food");
  };

  let heading = <>{newProductHeading}</>;
  if (modalMode === MODAL.VIEW) {
    heading = <>{viewProductHeading}</>;
  } else if (modalMode === MODAL.EDIT) {
    heading = <>{editProductHeading}</>;
  }

  const renderModalBody =
    modalModeInit === MODAL.WRITE ||
    (loaderData && loaderData.success && modalModeInit === MODAL.VIEW);

  const navBarHeight = "65px";

  return (
    <Modal
      show={show}
      onHide={onModalHide}
      animation={true}
      size="lg"
      style={{ marginTop: navBarHeight, zIndex: "1200" }}
      dialogClassName="rebrand-product-modal-dialog"
      contentClassName="rebrand-product-modal"
    >
      <IconButton
        aria-label="close"
        onClick={onModalHide}
        sx={{
          position: "absolute",
          right: 14,
          top: 14,
          zIndex: 1000,
          backgroundColor: "#1f1615",
          border: "1px solid rgba(131, 60, 65, 0.28)",
          borderRadius: "7px",
          "&:hover": {
            backgroundColor: "rgba(131, 60, 65, 0.2)",
          },
          color: "#f0ece8",
        }}
      >
        <CloseIcon sx={{ fontSize: "16px" }} />
      </IconButton>
      <Modal.Header>
        <Stack direction="row" spacing={1.2} alignItems="center">
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "8px",
              display: "grid",
              placeItems: "center",
              bgcolor: "rgba(131, 60, 65, 0.18)",
              color: "#9e4a50",
            }}
          >
            <Inventory2OutlinedIcon sx={{ fontSize: 17 }} />
          </Box>
          <Box>
            <Typography
              sx={{
                color: "#f0ece8",
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: 1.1,
              }}
            >
              {heading}
            </Typography>
            <Typography
              sx={{
                color: "#7a6560",
                fontSize: "11px",
                mt: 0.3,
              }}
            >
              Manage product details, visibility, pricing, and media.
            </Typography>
          </Box>
        </Stack>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
        <Box
          sx={{
            marginBottom: "10px",
          }}
        >
          <FeedbackAlert
            show={feedback.show}
            message={feedback.message}
            type={feedback.type}
            timeout={feedback.timeout}
          />
        </Box>
        {renderModalBody ? (
          <ModalBody
            modalMode={modalMode}
            activeProduct={productInState || emptyProductObject}
            productType={productType}
          />
        ) : (
          <div>{somethingWentWrong}</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProductModal;
